import {
  Button,
  Grid,
  Paper,
  styled,
  Tab,
  Tabs,
  Typography,
  TextField as TextFieldMt,
} from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import {
  useContext,
  useRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react'
import { GlobalContext } from '../../../App'
import dayjs from 'dayjs'
import PrimeTable from '../../../components/PrimeTable'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { GiPayMoney, GiReceiveMoney, GiTakeMyMoney } from 'react-icons/gi'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  height: 100,
  marginTop: 8,
  color: theme.palette.text.secondary,
}))

const retornaPontoVenda = (u = []) => ({
  idAtendimento: u?.[0] || undefined,
  acPaciente: u?.[1] || [],
  idPaciente: u?.[1]?.[0]?.[0] || undefined,
  dsLocal: u?.[2] || undefined,
  dsAtendimento: u?.[3] || undefined,
  dtInicio: u?.[4] ? dayjs(u[4]).format('YYYY-MM-DDTHH:mm') : '',
  dtFim: u?.[5] ? dayjs(u[5]).format('YYYY-MM-DDTHH:mm') : '',
  atendido: u?.[6] || 0.0,
  pago: u?.[7] || 0.0,
})

const FormularioConteudo = ({
  isSubmitting,
  submitForm,
  setFieldValue,
  values,
  localAtendimento,
  voltar,
}) => {
  const [refresh, setRefresh] = useState(0)
  const [refreshPgts, setRefreshPgts] = useState(0)
  const [pagamentos, setPagamentos] = useState(values.pago)
  const [atendimentos, setAtendimentos] = useState(values.atendido)
  const [resultado, setResultado] = useState(values.pago - values.atendido)
  const [tab, setTab] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('excluiItem', {
      idAtendimento: dados[0],
      sqAtendimento: dados[1],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaItem = async (dados) => {
    const payload = {
      idAtendimento: values.idAtendimento,
      sqAtendimento: dados?.[1],
      idUsuarioAtendeu: dados.acUsuario?.[0]?.[0],
      vlAtendimento: dados.vlAtendimento,
      dtRegistro: dados.dtRegistro
        ? dayjs(dados.dtRegistro).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      dsAtendimento: dados.dsAtendimento,
    }

    const resp = await metodoPrograma('salvaItem', payload)
    if (resp.status) {
      setRefresh((prev) => prev + 1)
    }
  }

  const editaItem = async (linha, close) => {
    const payload = {
      idAtendimento: linha?.[0],
      sqAtendimento: linha?.[1],
      idUsuarioAtendeu: linha?.[2]?.[0]?.[0],
      dsAtendimento: linha?.[3],
      dtRegistro: linha?.[4]
        ? dayjs(linha?.[4]).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      vlAtendimento: linha?.[5],
    }

    const resp = await metodoPrograma('salvaItem', payload)
    if (resp.status) {
      setRefresh((prev) => prev + 1)
    }
    close()
  }

  const salvaPagamento = async (dados) => {
    const payload = {
      idAtendimento: values.idAtendimento,
      sqPagamento: dados?.[1],
      vlPagamento: dados.vlPagamento,
      dtPagamento: dados.dtPagamento
        ? dayjs(dados.dtPagamento).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      dsPagamento: dados.dsPagamento,
    }

    const resp = await metodoPrograma('salvaPagamento', payload)
    if (resp.status) {
      setRefreshPgts((prev) => prev + 1)
    }
  }

  const editaPagamento = async (linha, close) => {
    const payload = {
      idAtendimento: linha?.[0],
      sqPagamento: linha?.[1],
      dsPagamento: linha?.[2],
      dtPagamento: linha?.[3]
        ? dayjs(linha?.[3]).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      vlPagamento: linha?.[4],
    }

    const resp = await metodoPrograma('salvaPagamento', payload)
    if (resp.status) {
      setRefreshPgts((prev) => prev + 1)
    }
    close()
  }

  const excluiPagamento = useCallback((dados) => {
    metodoPrograma('excluiPagamento', {
      idAtendimento: dados[0],
      sqPagamento: dados[1],
    }).then((res) => {
      if (res.status) {
        setRefreshPgts((prev) => prev + 1)
      }
    })
  }, [])

  useEffect(() => {
    if (values.idAtendimento) {
      metodoPrograma('getTotais', {
        idAtendimento: values.idAtendimento,
        parametro: refresh,
        parametro1: refreshPgts,
      }).then((res) => {
        if (res.status) {
          setPagamentos(res.pagamentos)
          setAtendimentos(res.atendimentos)
          setResultado(res.pagamentos - res.atendimentos)
        }
      })
    }
  }, [refresh, refreshPgts, values])

  const searchPaciente = useMemo(
    () => ({
      idLocalAtendimento: localAtendimento[0],
      idAtendimento: values.idAtendimento,
    }),
    [localAtendimento, values.idAtendimento],
  )

  return (
    <Form style={{ width: '100%', padding: 0 }}>
      {values.idAtendimento && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}></Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Item
              style={{
                backgroundColor: 'rgb(67 160 71 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={4}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiReceiveMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={8}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Pagamentos
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {pagamentos.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Item
              style={{
                backgroundColor: 'rgb(214 19 19 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={4}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiPayMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={8}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Atendimentos
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {atendimentos.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Item
              style={{
                backgroundColor: 'rgb(4 52 239 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={4}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiTakeMyMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={8}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Resultado Geral
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {resultado.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Paciente"
            metodo="buscaPaciente"
            value={values.acPaciente}
            searchParams={searchPaciente}
            onChange={(_, v) => {
              setFieldValue('idPaciente', v?.[0]?.[0])
              setFieldValue('acPaciente', v)
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dsLocal"
            label="Local do Atendimento"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dsAtendimento"
            label="Descrição detalhada do atendimento"
            multiline
            minRows={3}
            maxRows={10}
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dtInicio"
            label="Início do Atendimento"
            type="datetime-local"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dtFim"
            label="Fim do Atendimento"
            type="datetime-local"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>

        {values.idAtendimento && (
          <Grid container spacing={2} style={{ marginTop: 25 }}>
            <Grid item xs={12}>
              <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab value={0} label="Atendimentos" />
                <Tab value={1} label="Pagamentos" />
              </Tabs>
            </Grid>
            {tab === 0 && (
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  style={{
                    backgroundColor: '#f5f5f5', // cinza bem claro
                    borderRadius: '12px', // bordas arredondadas
                    padding: '16px',
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ marginBottom: '10px', fontWeight: 500 }}
                  >
                    Atendimentos
                  </Typography>
                  <PrimeTable
                    action="listaItem"
                    codigo="CtrlAtendimentoExterno"
                    refresh={refresh}
                    parametros={{ idAtendimento: values.idAtendimento }}
                    head={['Funcionário', 'Descrição', 'Data', 'Custo']}
                    line={(item) => [
                      item[2]?.[1] || '',
                      item[3],
                      item[4],
                      item[5],
                    ]}
                    collumnsCurrency={[3]}
                    collumnsDateHour={[2]}
                    editButton={true}
                    addButton={true}
                    onDelete={{ index: 10, action: exclui }}
                    fastAddComponent={({ values, edit, close }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <AutoComplete
                            metodo="buscaUsuario"
                            codigo="CtrlProposta"
                            value={values?.acUsuario}
                            name="acUsuario"
                            label="Funcionário que Atendeu"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            onChange={async (_, val) => {
                              await edit({
                                value: val,
                                field: 'acUsuario',
                              })
                            }}
                            textFieldProps={{
                              helperText: !values?.acUsuario
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !values?.acUsuario,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dsAtendimento"
                            label="Descrição do Atendimento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={values?.dsAtendimento}
                            onChange={(e) =>
                              edit({
                                value: e.target.value,
                                field: 'dsAtendimento',
                              })
                            }
                            helperText={
                              !values?.dsAtendimento ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.dsAtendimento}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dtRegistro"
                            label="Data Atendimento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            type="datetime-local"
                            value={values?.dtRegistro}
                            onChange={(e) =>
                              edit({
                                value: e.target.value,
                                field: 'dtRegistro',
                              })
                            }
                            helperText={
                              !values?.dtRegistro ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.dtRegistro}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="vlAtendimento"
                            label="Valor"
                            size="small"
                            value={values?.vlAtendimento}
                            onChange={(v) =>
                              edit({ value: v, field: 'vlAtendimento' })
                            }
                            helperText={
                              !values?.vlAtendimento ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.vlAtendimento}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!values?.vlAtendimento &&
                                !!values?.acUsuario &&
                                !!values?.dsAtendimento &&
                                !!values?.dtRegistro &&
                                salvaItem(values) &&
                                close()
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    fastEditComponent={({ linha, close, edit }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <AutoComplete
                            metodo="buscaUsuario"
                            codigo="CtrlProposta"
                            name="acUsuario"
                            label="Funcionário que Atendeu"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={linha[2]}
                            onChange={(_, val) =>
                              edit({ value: val, index: 2 })
                            }
                            textFieldProps={{
                              helperText: !linha?.[2]
                                ? 'Campo Obrigatório!'
                                : '',
                              error: !linha?.[2],
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dsAtendimento"
                            label="Descrição do Atendimento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={linha[3]}
                            onChange={(e) =>
                              edit({ value: e.target.value, index: 3 })
                            }
                            helperText={!linha?.[3] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[3]}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dtRegistro"
                            label="Data Atendimento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            type="datetime-local"
                            value={linha[4]}
                            onChange={(v) => edit({ value: v, index: 4 })}
                            helperText={!linha?.[4] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[4]}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="vlAtendimento"
                            label="Valor"
                            size="small"
                            value={linha[5]}
                            onChange={(v) => edit({ value: v, index: 5 })}
                            helperText={!linha?.[5] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[5]}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!linha?.[2] &&
                                !!linha?.[3] &&
                                !!linha?.[4] &&
                                !!linha?.[5] &&
                                editaItem(linha, close) &&
                                close()
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  />
                </Paper>
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  style={{
                    backgroundColor: '#f5f5f5', // cinza bem claro
                    borderRadius: '12px', // bordas arredondadas
                    padding: '16px',
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{ marginBottom: '10px', fontWeight: 500 }}
                  >
                    Pagamentos
                  </Typography>
                  <PrimeTable
                    action="listaPagamento"
                    codigo="CtrlAtendimentoExterno"
                    refresh={refreshPgts}
                    parametros={{ idAtendimento: values.idAtendimento }}
                    head={['Descrição', 'Data', 'Valor']}
                    line={(item) => [item[2], item[3], item[4]]}
                    collumnsCurrency={[2]}
                    collumnsDateHour={[1]}
                    editButton={true}
                    addButton={true}
                    onDelete={{ index: 10, action: excluiPagamento }}
                    fastAddComponent={({ values, edit, close }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dsPagamento"
                            label="Descrição do Pagamento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={values?.dsPagamento}
                            onChange={(e) =>
                              edit({
                                value: e.target.value,
                                field: 'dsPagamento',
                              })
                            }
                            helperText={
                              !values?.dsPagamento ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.dsPagamento}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dtPagamento"
                            label="Data Pagamento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            type="datetime-local"
                            value={values?.dtPagamento}
                            onChange={(e) =>
                              edit({
                                value: e.target.value,
                                field: 'dtPagamento',
                              })
                            }
                            helperText={
                              !values?.dtPagamento ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.dtPagamento}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="vlPagamento"
                            label="Valor"
                            size="small"
                            value={values?.vlPagamento}
                            onChange={(v) =>
                              edit({ value: v, field: 'vlPagamento' })
                            }
                            helperText={
                              !values?.vlPagamento ? 'Campo Obrigatório!' : ''
                            }
                            error={!values?.vlPagamento}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!values?.dsPagamento &&
                                !!values?.dtPagamento &&
                                !!values?.vlPagamento &&
                                salvaPagamento(values) &&
                                close()
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                    fastEditComponent={({ linha, close, edit }) => (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dsPagamento"
                            label="Descrição do Pagamento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            value={linha[2]}
                            onChange={(e) =>
                              edit({ value: e.target.value, index: 2 })
                            }
                            helperText={!linha?.[2] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[2]}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextFieldMt
                            InputLabelProps={{ shrink: true }}
                            name="dtPagamento"
                            label="Data Pagamento"
                            fullWidth
                            margin="dense"
                            variant="outlined"
                            size="small"
                            type="datetime-local"
                            value={linha[3]}
                            onChange={(e) =>
                              edit({ value: e.target.value, index: 3 })
                            }
                            helperText={!linha?.[3] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[3]}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <CurrencyField
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            name="vlPagamento"
                            label="Valor"
                            size="small"
                            value={linha[4]}
                            onChange={(v) => edit({ value: v, index: 4 })}
                            helperText={!linha?.[4] ? 'Campo Obrigatório!' : ''}
                            error={!linha?.[4]}
                          />
                        </Grid>
                        <Grid
                          item
                          container
                          xs={12}
                          spacing={2}
                          justifyContent="flex-end"
                        >
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={close}
                              fullWidth
                              variant="contained"
                              color="inherit"
                              style={{ margin: '5px' }}
                            >
                              Cancelar
                            </Button>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <Button
                              onClick={() =>
                                !!linha?.[2] &&
                                !!linha?.[3] &&
                                !!linha?.[4] &&
                                editaPagamento(linha, close) &&
                                close()
                              }
                              variant="contained"
                              fullWidth
                              color="primary"
                              style={{ margin: '5px' }}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  />
                </Paper>
              </Grid>
            )}
          </Grid>
        )}

        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            onClick={submitForm}
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>

          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </Form>
  )
}

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const formik = useRef(null)

  const salva = async (values) => {
    const payload = {
      ...values,
      dtInicio: values?.dtInicio
        ? dayjs(values.dtInicio).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
      dtFim: values?.dtFim
        ? dayjs(values.dtFim).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }

    const res = await metodoPrograma('salva', payload)

    if (res.status) voltar()
  }

  return (
    <Formik
      innerRef={formik}
      initialValues={retornaPontoVenda(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {(props) => (
        <FormularioConteudo
          {...props}
          localAtendimento={localAtendimento}
          voltar={voltar}
        />
      )}
    </Formik>
  )
}

export default Edicao
